import { Page } from '@/core/architecture'

import { NotificationDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * NotificationDetail Page
 * Implemented as a practical sample.
 */
export const NotificationDetail: Page = () => {
  const { state } = useViewModel()

  return <NotificationDetailTemplate state={state} />
}
